import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

const servicesService = {
  // Get services data (Collection Type)
  async getAllServices(params = {}) {
    try {
      const response = await api.get('/services', {
        params: {
          populate: {
            serviceFeatures: {
              populate: ['featureOptions']
            },
            solutionsPoints: true,
            imageHeader: true,
            cardIcon: true
          },
          ...params
        }
      });
      
      return {
        data: response.data.data || [],
        meta: response.data.meta || {},
        success: true
      };
    } catch (error) {
      console.error('Error fetching services:', error);
      return {
        data: [],
        meta: {},
        success: false,
        error: error.message
      };
    }
  },

  // Get single service by ID
  async getServiceById(id, params = {}) {
    try {
      const response = await api.get('/services', {
        params: {
          'filters[documentId][$eq]': id,
          populate: {
            serviceFeatures: {
              populate: ['featureOptions']
            },
            solutionsPoints: true,
            imageHeader: true,
            cardIcon: true
          },
          ...params
        }
      });
      
      if (response.data.data && response.data.data.length > 0) {
        return {
          data: response.data.data[0],
          success: true
        };
      }

      return {
        data: null,
        success: false,
        error: 'Service not found'
      };
    } catch (error) {
      console.error('Error fetching service by ID:', error);
      return {
        data: null,
        success: false,
        error: error.message
      };
    }
  }
};

export { servicesService };
export default servicesService;
